// extracted by mini-css-extract-plugin
module.exports = {"container":"sidenav_container__3E-lE","dropdown":"sidenav_dropdown__1vZk3"};